import { axios } from '@/utils/request'

const api = {
  addEntModel: '/enterprise/entModel/addEntModel',
  entModelListSearch: '/enterprise/entModel/entModelListSearch',
  deleteEntModel: '/enterprise/entModel/deleteEntModel',
  enableEntModel: '/enterprise/entModel/enableEntModel',
  disableEntModel: '/enterprise/entModel/disableEntModel',
  getModelByEnterprise: '/enterprise/entModelRelation/getModelByEnterprise',
  getEntModelRelationDeatil: '/enterprise/entModelRelation/getEntModelRelationDetail',
  configEntModelRelation: '/enterprise/entModelRelation/configEntModelRelation',
  getEntModelDetail: '/enterprise/entModel/getEntModelDetail',
  saveApprovalSaleOrder: '/enterprise/entModel/saveApprovalSaleOrder',
  editEntModel: '/enterprise/entModel/editEntModel',
  brand: '/enterprise/brand',
  model: '/enterprise/model',
}

//1.1.5编辑企业模板
export function editEntModel(parameter) {
  return axios({
    url: api.editEntModel,
    method: 'post',
    data: parameter
  })
}

//1.1.4保存销单资料
export function saveApprovalSaleOrder(parameter) {
  return axios({
    url: api.saveApprovalSaleOrder,
    method: 'post',
    data: parameter
  })
}

// 品牌
export function getSelectBrand(parameter) {
  return axios({
    url: api.brand + '/selectBrand',
    method: 'get',
    params: parameter
  })
}
// 型号
export function getModelNumber(parameter) {
  return axios({
    url: api.model + '/selectModel',
    method: 'get',
    params: parameter
  })
}

//获取企业模板详情
export function getEntModelDetail(parameter) {
  return axios({
    url: api.getEntModelDetail,
    method: 'get',
    params: parameter
  })
}

//新建企业模板
export function addEntModel(parameter) {
  return axios({
    url: api.addEntModel,
    method: 'post',
    data: parameter
  })
}

// 模板列表查询
export function entModelListSearch(parameter) {
  return axios({
    url: api.entModelListSearch,
    method: 'get',
    params: parameter
  })
}

// 删除模板
export function deleteEntModel(parameter) {
  return axios({
    url: api.deleteEntModel,
    method: 'get',
    params: parameter
  })
}

// 启用模板
export function enableEntModel(parameter) {
  return axios({
    url: api.enableEntModel,
    method: 'get',
    params: parameter
  })
}

// 禁用模板
export function disableEntModel(parameter) {
  return axios({
    url: api.disableEntModel,
    method: 'get',
    params: parameter
  })
}

// 1.1.11获取企业模板关联详情
export function getEntModelRelationDeatil(parameter) {
  return axios({
    url: api.getEntModelRelationDeatil,
    method: 'get',
    params: parameter
  })
}

//根据企业查询型号
export function getModelByEnterprise(parameter) {
  return axios({
    url: api.getModelByEnterprise,
    method: 'post',
    data: parameter
  })
}

//1.1.10配置企业模板关联
export function configEntModelRelation(parameter) {
  return axios({
    url: api.configEntModelRelation,
    method: 'post',
    data: parameter
  })
}
export const channelExport = api.channel + '/export'

export function getOrderType(parameter) {
  return axios({
    url: '/basicdata/orderType/getList/SMART_SWITCH',
    method: 'get',
    params: parameter
  })
}
export function getModelName(parameter) {
  return axios({
    url: '/enterprise/entModel/getEntModelDetailByModelId',
    method: 'get',
    params: parameter
  })
}
export function getSaleName(parameter) {
  return axios({
    url: '/enterprise/saleName/getEzvizSouanSaleName',
    method: 'get',
    params: parameter
  })
}

export function addSaleName(parameter) {
  return axios({
    url: '/enterprise/saleName/insertEzvizSouanSaleName',
    method: 'post',
    data: parameter
  })
}